/* Publish by EComposer at 2026-10-08 18:03:39*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-hl3wxm2iiq"]=  window.__ectimmers["ecom-hl3wxm2iiq"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-hl3wxm2iiq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hl3wxm2iiq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qs49hjeguef').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qs49hjeguef', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-midb98kog8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-midb98kog8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uhb3jxarwxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uhb3jxarwxm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4g3nmrpm3ce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4g3nmrpm3ce', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gbnj2ar1k1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gbnj2ar1k1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1sdljb82p3u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1sdljb82p3u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-12249rtly0a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-12249rtly0a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a2ock3ad8x9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a2ock3ad8x9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g7wxgr1qwf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g7wxgr1qwf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-furikt2hmpp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-furikt2hmpp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4961xa8p497').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4961xa8p497', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i12f0yn366q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i12f0yn366q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fyoj633el3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fyoj633el3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hawyc8ucv9n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hawyc8ucv9n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m0rvuir6jac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m0rvuir6jac', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t4r2ohxa52r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t4r2ohxa52r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pi4xj6run2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pi4xj6run2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y5r5zk9t94p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y5r5zk9t94p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vfrsskc5z3l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfrsskc5z3l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kog3lpsj2ul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kog3lpsj2ul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7ff36ltcd1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7ff36ltcd1e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1yq0to92b03').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1yq0to92b03', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ajlf4dr2w4p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ajlf4dr2w4p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4nppp969q6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4nppp969q6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nsd11787uvk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nsd11787uvk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rupjgh93an').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rupjgh93an', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w5lq3k9e0cj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w5lq3k9e0cj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g0kjn0z8o1g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g0kjn0z8o1g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5evxxt0k3d7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5evxxt0k3d7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-klavgq3q2oi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-klavgq3q2oi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3twl6shu2ys').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3twl6shu2ys', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fwcz2b60fca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fwcz2b60fca', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hhig4ynsvbi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hhig4ynsvbi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ek3ad3kmmsj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ek3ad3kmmsj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oubqtoesxxo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oubqtoesxxo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lohkfm54p8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lohkfm54p8', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-alc1cxrq8zb"]=  window.__ectimmers["ecom-alc1cxrq8zb"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),o=this.settings.action;function n(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var m;(m=d.ec_splide)==null||m.refresh()})},50),r())}e.forEach((a,l)=>{o==="click"||window.screen.width<1025?a.onclick=()=>n(a,l):a.onmouseover=()=>n(a,l)});function s(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let g=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,g)}}}setTimeout(()=>{s()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-alc1cxrq8zb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-alc1cxrq8zb', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-w7mk2nu15p"]=  window.__ectimmers["ecom-w7mk2nu15p"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-w7mk2nu15p"]["1givvu86d"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-w7mk2nu15p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w7mk2nu15p', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);};window.addEventListener("load",()=>{
                let isAdmin = false;
                if(document.querySelector("#admin-bar-iframe")){
                    isAdmin = true;
                }
                if(!isAdmin) {
                    if(window.EComposerBrand) {
                        return;
                    } else {
                        window.EComposerBrand = true;
                    }
                }
                let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 11px","width: 100%","text-align: center","opacity: 1","text-indent: 0","color: rgba(18, 18, 18, 0.75)","background: transparent","opacity: 0.8",""].join(" !important;")),b.innerHTML="Built with <a style='color: currentColor;text-decoration: none;' href=\"https://ecomposer.io/?utm_source=client-site&utm_medium=footer&utm_campaign=footer_branding&utm_term=links&utm_content="+window.location.origin+"\" target=\"_blank\">EComposer</a>" + (isAdmin ? ". Contact us or upgrade to remove branding" :""),a.appendChild(b)
            });